/**
 * This file is delete-only, please do not add new colours.
 */

// blue
const skyBlue = `#3EC1F3`;
export const royalBlue = `#4856DF`;
export const fadedBlue = `rgb(72, 86, 223, 0.16)`;

export const toRightGradientVibrantBlue = `linear-gradient(to right, ${royalBlue}, ${skyBlue});`;
